import store from '@/store/vuex'
import Cubemap from '@/store/vuex/manager/cubemap'
import { CATEGORYNAMES } from '@/api/constants'
import { pipe, sort, filter, map } from '@/api/utils'
import { coords3dTo2d } from '@/api/helpers'
import { resizeCDNImage } from '@/utils/resize'
import { cloneDeep } from 'lodash'

const makeCopy = obj => cloneDeep(obj)

const setImageResizing = panorama => {
  if (panorama.thumbnail.includes('thumbnail') && !panorama.thumbnail.includes('custom')) {
    panorama.previewUrl = panorama.thumbnail
  } else {
    panorama.previewUrl = resizeCDNImage(panorama.desktopUrl, 400, 80)
  }
  panorama.adjustedRawUrl = resizeCDNImage(panorama.adjustedRawUrl, 8192, 80)
  if (!panorama.desktopUrl.includes('desktop')) panorama.desktopUrl = resizeCDNImage(panorama.desktopUrl, 8192, 80)
  return panorama
}
const filterMosaicMarkersOut = panorama => {
  panorama.markers = panorama.markers.filter(marker => marker.type !== 'mosaic')
  return panorama
}
const setMarkersRelation = panorama => {
  panorama.markers = panorama.markers.map(marker => {
    marker.panoramaId = panorama.objectId
    marker.buildingId = panorama.buildingId
    return marker
  })
  return panorama
}
const setCubeMap = panorama => {
  const cubemap = new Cubemap(panorama, store.state.user.userId)
  cubemap.init()
  if (panorama.cubemapReady === true) {
    panorama.cubemapPreivewUrl = cubemap.preivewUrl
    panorama.cubemapUrl = cubemap.cubeUrl
  }
  return panorama
}
const setCustomCategory = panorama => {
  if (CATEGORYNAMES[panorama.category] == null) {
    panorama.customCategory = panorama.category
    panorama.category = 'custom'
  }
  return panorama
}
const setDefaultPosition = panorama => {
  if (!panorama.position) {
    panorama.position = { x: 0, y: 0 }
  }
  return panorama
}
const setVideo = panorama => {
  panorama.videoAttribute = panorama.videoAttribute ? JSON.parse(panorama.videoAttribute) : ''
  if (panorama.videoAttribute) {
    // Just render a black scene
    panorama.desktopUrl = 'https://vrmaker.istaging.com/00000photoUpload/360video_panorama_blank.jpg'
  }
  return panorama
}
export const formatPanorama = pipe(
  makeCopy,
  setImageResizing,
  filterMosaicMarkersOut,
  setCustomCategory,
  setDefaultPosition,
  setCubeMap,
  setMarkersRelation,
  setVideo
)
export const formatPanoramas = pipe(
  // removeRepeat,
  filter(panorama => panorama.rawUrl), // app maybe create a panorama but not upload photo yet
  sort((a, b) => a.index - b.index),
  map(formatPanorama)
)

const get2dPosition = marker => {
  const { ath, atv } = coords3dTo2d(marker.position)
  marker.position.ath = ath
  marker.position.atv = atv
  return marker
}
const formatMarkerProperty = marker => {
  marker.category = marker.category || []
  return marker
}
const formatMarkerMulti = marker => {
  marker.nameMulti = marker.nameMulti ? JSON.parse(marker.nameMulti) : {}
  marker.descriptionMulti = marker.descriptionMulti ? JSON.parse(marker.descriptionMulti) : {}
  marker.categoryMulti = marker.categoryMulti ? JSON.parse(marker.categoryMulti) : {}
  marker.priceMulti = marker.priceMulti ? JSON.parse(marker.priceMulti) : {}
  marker.actionMulti = marker.actionMulti ? JSON.parse(marker.actionMulti) : {}
  marker.actionLinkMulti = marker.actionLinkMulti ? JSON.parse(marker.actionLinkMulti) : {}
  return marker
}
const formatMarkerTagPhoto = marker => {
  if (marker.type === 'tag') {
    marker.images = marker.photo ? marker.photo.split(',') : []
  }
  if (marker.type === 'multitag') {
    marker.multitagInfo.forEach(info => {
      info.images = info.photo ? info.photo.split(',') : []
    })
  }
  return marker
}
const formatMultitagCategory = marker => {
  if (marker.type === 'multitag') {
    marker.multitagInfo.forEach(info => {
      info.category = marker.category
      info.categoryMulti = marker.categoryMulti
    })
  }
  return marker
}
export const formatMarker = pipe(
  get2dPosition,
  formatMarkerProperty,
  formatMarkerMulti,
  formatMarkerTagPhoto,
  formatMultitagCategory
)
